import axios from "@/lib/axios";

export type DownloadQuizExcelRequestParams = {
  companyId: string;
  applicationQuizId: string;
};

export type DownloadQuizExcelResponse = Blob;

export const downloadQuizExcelRequest = (
  params: DownloadQuizExcelRequestParams,
) =>
  axios.get<DownloadQuizExcelResponse>(
    `/v1/companies/${params.companyId}/application-quizzes/${params.applicationQuizId}/export`,
    {
      responseType: "blob",
    },
  );
